<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-21"></a><span href="#/toc#toc-chapter003" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> T<span class="small-caps">WO</span></span></h1>
<p class="img1"><img alt="image" src="images/Art_orn.jpg"/></p>
<p class="noindent"><span class="dropcap">Z</span>ane was whistling as he descended the stairs and walked to the kitchen.
      </p>
<p>At the Lost Nugget Ranch, breakfast was an important meal, bringing everyone together before they went their separate ways
         for the day. And, because ranch chores started at dawn, the men had often put in several hours of hard work before breakfast.
      </p>
<p>Jesse and Amy were already seated at the table, along with Wyatt and Marilee.</p>
<p>Cora, who had returned to the ranch sometime during the night, was engaged in a familiar argument with Cal.</p>
<p>“I was never in any danger, Cal.” Cora’s tone was patient.</p>
<p>“So you say. But you admitted that the heavy snow brought down a tree right beside your tent. You could be lying out there
         right now, pinned and gravely wounded, and we wouldn’t have a clue.”
      </p>
<p><a id="page-22"></a>“Cal, I always have my cell phone under my pillow.”
      </p>
<p>“A lot of good that would do if you were crushed beneath a tree. The calendar may say it’s springtime, but somebody forgot
         to tell Mother Nature. If it isn’t a tree falling, it could be an avalanche. And there you are, all alone in the wilderness,
         at the mercy of any number of dangers.”
      </p>
<p>Cora gave a long, deep sigh. “You know I’m not going to give up my art excursions. It’s where I do my best work. I love it
         too much to ever stop.”
      </p>
<p>“And I’m not going to stop worrying. I’ve been doing it too long.”</p>
<p>“Now, children,” Jesse said with a laugh. “There will be no fighting at the table.”</p>
<p>That eased the tension as everyone, even Cal and Cora, joined in the laughter.</p>
<p>Jesse turned to Zane. “You look awfully happy this morning.”</p>
<p>Cal sipped orange juice. “Could it be because you’re driving into town to pick up Riley Mason?”</p>
<p>“The new accountant that everyone figured was a man?” Jesse’s remark brought a round of laughter.</p>
<p>“A man?” Cora looked intrigued.</p>
<p>“Because of the name, I guess.” Zane merely smiled as he settled himself at the table. “Actually, Aunt Cora, she’s a real
         looker.”
      </p>
<p>Jesse winked at his wife. “I heard a cowboy say that about Daffy Spence last week. Of course, that was after his tenth beer.”</p>
<p>Daffy and her twin sister, Vi, owners and operators of the Fortune Saloon in Gold Fever, were both stick-thin, and wore their
         purple hair spiked, their eyes ringed with enough jet-black liner to give them the appearance of <a id="page-23"></a>flirty raccoons. Their age was a source of constant speculation, though one thing was certain. Whatever their birth certificates
         said, they were still young and frisky enough to bed the occasional bartender or willing customer.
      </p>
<p>“Good one, cuz.” Zane slapped him on the back. “It wouldn’t take getting drunk to find Riley Mason easy to look at.”</p>
<p>Something in his tone had the others studying him more closely.</p>
<p>“This sounds interesting.” Wyatt dropped an arm around Marilee’s shoulders. “You thinking of getting better acquainted with
         easy-to-look-at Riley Mason?”
      </p>
<p>“It may have crossed my mind. But just in the interest of good business relations, of course.”</p>
<p>When Dandy began passing around platters of sausage and toast and omelets, Zane turned to Cal, ready to change the subject.
         “I happened to get a look at your office on my way in here. It looks like a tornado blew through. Good thing you’re getting
         some much-needed help with the paperwork.”
      </p>
<p>The ranch foreman ran a hand through his white hair. “I’m buried under a mountain of bank ledgers and legal documents.”</p>
<p>Cora laid a hand over Cal’s. “It would certainly ease your burden if you’d just move into Coot’s suite upstairs. That way
         you could work on some of the books after supper, instead of getting talked into playing poker in the bunkhouse.”
      </p>
<p>Jesse winked at his cousins across the table. “Let’s see. Spend your evenings poring over bank ledgers, or playing poker with
         the wranglers. Hey, everybody knows that boring paperwork wins every time.”
      </p>
<p><a id="page-24"></a>Cal chuckled. “Given a choice, I’d rather skip both and be up on the range, especially with spring calving here and the herds
         mired in snow.”
      </p>
<p>“Most of the wranglers are feeling the same way.” Jesse dug into his meal. “They’ve spent way too many hours cooped up and
         can’t wait to get back to the hills along with the herd. Not even a good poker game can hold a candle to that.”
      </p>
<p>Cal nodded. “It’s that old springtime itch. I’ve got it bad.” He turned to the woman beside him. “As for moving into Coot’s
         rooms in this big house, we’ve been over this before, Cora. I’m just not ready. I may fill some of the hole left by Coot,
         but as for the rest…”
      </p>
<p>His words trailed off, but everyone in the room understood his reluctance. His best friend’s things were just as Coot had
         left them. From the wide-brimmed hats and custom-made boots in the closet to the books he’d devoured and the letters he’d
         saved from family and friends, Coot’s presence could be felt everywhere on this vast ranch, but the feelings were strongest
         in his own suite of rooms, where nothing had been touched since his death nearly a year earlier.
      </p>
<p>To ease the tension Jesse abruptly turned to the foreman. “So, where are you going to put your new accountant, now that you’ve
         learned she’s a female? I don’t think she’d be comfortable in the bunkhouse.”
      </p>
<p>Cal turned to Cora. “I was thinking about the room next to the office. But that’s when I thought we were hiring a guy. Now
         that I’ve learned that she has a four-year-old, I’m thinking maybe she’d be more comfortable in Annie’s Retreat. What do you
         think?”
      </p>
<p><a id="page-25"></a>Zane looked thunderstruck. “A kid? Riley Mason has a kid?”
      </p>
<p>“Named Summer,” Cal said easily. “Did I forget to mention her?”</p>
<p>“Yeah. You did.” Zane tried to picture the gorgeous accountant in the role of mother. Somehow, the image didn’t fit. And wife.
         Her image blurred a bit more.
      </p>
<p>Cora’s smile bloomed. “A little girl. How sweet. I’m sure she’ll love living on the ranch.” She turned to Cal. “Annie’s Retreat.”
         Her voice turned dreamy. “I remember when my sister-in-law decorated those rooms and turned them into her hideaway. Cal, it
         hasn’t been put to use in years. It’s perfect for a family.”
      </p>
<p>Cal shook his head. “There’s just the two of them. No husband, she told me.”</p>
<p>That sparked Zane’s interest. No man in her life. At least not now.</p>
<p>Cal’s words broke through his musings. “That’s it, then. As long as Cora agrees, it looks like you’ll have to carry their
         things up a flight of stairs.”
      </p>
<p>“No problem.” Though Zane was still reeling from the revelations about their pretty new bookkeeper he managed to say, “Being
         a pack mule is one of my many talents.”
      </p>
<p>That had the others laughing before Jesse said, “Let’s just hope our new accountant has enough talent to clean up the mess
         in Cal’s office.”
      </p>
<p>Cal gave a shake of his head. “I’m not worried. She had excellent references, going all the way back to working at a coffee
         shop near her campus.”
      </p>
<p>That had Cora smiling. “I remember my first job in college.”</p>
<p><a id="page-26"></a>“At a coffee shop?” Amy asked.
      </p>
<p>Cora chuckled. “They weren’t popular then. I applied for a job as a waitress in an off-campus bar. I got the job and hated
         every minute of it. I’d rather work alone in the dreariest job imaginable than have to put up with dozens of drunks all demanding
         attention at the same time, especially as it got closer to quitting time. I found myself forgetting drink orders, making mistakes
         on the bills, and spilling more drinks than I could keep track of.”
      </p>
<p>That had her great-nephews smiling.</p>
<p>Wyatt shook his head. “It’s hard to imagine you working as a waitress in some college-town bar, Aunt Cora. Were you wearing
         Coot’s overalls back then?”
      </p>
<p>The older woman put a hand to her hip. “I’ll have you know I was once considered quite a babe.”</p>
<p>While the others were grinning, Cal rushed to her defense. “Still are to me, Cora.”</p>
<p>Then, realizing what he’d just said, his face reddened.</p>
<p>His discomfort wasn’t lost on the others.</p>
<p>Amy and Marilee exchanged meaningful looks, while Jesse, Wyatt, and Zane jumped at the chance to start teasing him.</p>
<p>“Careful, Cal.” Jesse winked at his cousins. “Next thing you know, Aunt Cora will invite you to her studio to pose for a portrait.”</p>
<p>Wyatt chuckled. “Just remember to keep your boots on, Cal.”</p>
<p>Clearly flustered, Cora pushed away from the table. “I’d better get to my studio and finish what I started out at camp.”</p>
<p>Cal got to his feet, grateful for a chance to escape. “I’ll bring in the rest of your things.”</p>
<p><a id="page-27"></a>She gave him a tender smile. “Thanks, Cal, but you have enough on your plate these days. I can manage.”
      </p>
<p>“I know you can, but I want to help.” Before she could protest further, he turned and made his way to the mudroom off the
         kitchen, where the custom wagon he’d made for her years earlier had been left crammed with supplies from her latest overnighter.
      </p>
<p>When he was gone, Cora glanced at Amy and Marilee before taking in a deep breath. “One day soon I intend to tackle Coot’s
         rooms and see if I can’t make some order out of them. With the anniversary of my brother’s death looming, I think most of
         his things should be put in storage. That would go a long way toward making Cal feel more comfortable about moving in. And
         I know I’d feel better sorting through Coot’s belongings. I hope I can count on both of you to lend a hand.”
      </p>
<p>Amy spoke for both of them. “You know we’ll help whenever you’re ready to face it, Aunt Cora.”</p>
<p>“Thank you.” She turned away and headed toward her studio in the rear of the house.</p>
<p>Minutes later Cal Randall followed, hauling in her supplies.</p>
<p>When they were alone, Wyatt turned to the others. “I’m glad Cal is getting the help he needs to ease some of the load from
         his shoulders.”
      </p>
<p>Jesse nodded. “I was just thinking the same thing. He’s taken on too much.” He got to his feet. “I’m going to head the first
         group of wranglers up to the high pasture.”
      </p>
<p>Zane glanced out the window, where a thick blanket of clouds had obscured the sun. “If this weather keeps up, we may have
         to skip spring altogether and go right to summer.”
      </p>
<p><a id="page-28"></a>Jesse drained his coffee. “I figure this is winter’s last hurrah. By this time next week I’m betting the last of the snow
         will be melting and the high country will be abloom with acres of green grass.”
      </p>
<p>“I’ll take that bet.” Zane whipped out a twenty and slapped it on the table. “I’m betting this latest storm will dump enough
         snow to stick around for two weeks or more.”
      </p>
<p>“Sucker.” Jesse dropped his own twenty and leaned over to kiss his wife. “Baby, I’ll be treating you to a couple of cold longnecks
         on Zane’s money this time next week.”
      </p>
<p>“In your dreams.” With a grin Zane sauntered away, leaving his cousins to stare after him.</p>
<p>In the barn Jimmy Eagle looked up from a stall where he’d been wrapping a mare’s leg. Spying Zane’s polished boots beneath
         new denims and shirt, he leaned on the rail. “You ducking ranch chores, son? You sure aren’t dressed for mucking stalls.”
      </p>
<p>Zane shot him a grin. “I volunteered to pick up Cal’s new accountant in town and help her move her stuff out to the ranch.”</p>
<p>“Her stuff? I thought he’d hired a city boy.”</p>
<p>Zane’s smile grew. “That’s what we all thought. Turns out Riley Mason is a female.” He peered over the stall. “What’s wrong
         with Vanilla?”
      </p>
<p>“I didn’t like the look of a cut on her leg. Treated it with some of my special ointment.”</p>
<p>Zane chuckled. Jimmy’s mysterious ointments were regarded as something of a miracle around the ranch. “I’ve had that treatment
         myself a time or two.”
      </p>
<p>Jimmy nodded and glanced at the scar on the younger man’s jaw. “I thought your mother would horsewhip me <a id="page-29"></a>when she found out I’d stitched up that cut and treated it without a doctor so you could get back out on the trail with your
         cousins.”
      </p>
<p>“As I recall, I was more concerned with missing an afternoon up in the foothills than I was about splitting my jaw clean open
         in that spill from old Skeeter.”
      </p>
<p>“He was a mean pony.” Jimmy slapped Zane’s shoulder. “You were the only one who could ever ride him.”</p>
<p>“Thanks to you.” Zane shook his head. “I believe you were the original horse-whisperer. Whatever you said to that pony, it
         turned things around. After that, he was as docile as an old plow horse.”
      </p>
<p>“I told him he possessed the spirit of my father’s father, and that it was his duty to make our family proud.”</p>
<p>“That’s what you say now. At the time, Jesse told me that you threatened Skeeter with the glue factory if he ever tossed me
         again.”
      </p>
<p>The old man looked Zane in the eye. “Which one of us do you choose to believe?”</p>
<p>“You’ve never steered me wrong, Jimmy.”</p>
<p>The two men shared an affectionate smile before Zane sauntered away, jingling the keys to a ranch truck.</p>
<p class="space-break">Zane parked the truck at the curb outside Delia Cowling’s neat white house. On the ride to town he’d had plenty of time to
         wrap his mind around the fact that Riley Mason had a daughter. He’d begun to imagine the fun of teaching the kid to saddle
         a horse and ride across the hills. Four wasn’t too young to start. Hadn’t his old friend and mentor Jimmy Eagle put him on
         a horse’s back as soon as he’d been old enough to walk?
      </p>
<p><a id="page-30"></a>He climbed the porch steps and knocked.
      </p>
<p>When Riley opened the door, he found himself staring.</p>
<p>“Hey.” It was all he could manage.</p>
<p>She was wearing skinny jeans and a T-shirt that hugged every curve. Her dark hair fell in soft waves to her shoulders. She
         wasn’t wearing a bit of makeup, and he found himself looking at perfect porcelain skin, laughing dark eyes, and a pale mouth
         rounded in surprise. If possible, she looked even better than she had, all prim and proper, in that business suit.
      </p>
<p>“Hi. We’re just about all packed. Would you like to… ?”</p>
<p>Her words ended abruptly when something careened into Riley’s legs, propelling her forward. If Zane hadn’t caught her, she’d
         have been knocked clear off the front porch.
      </p>
<p>Riley stepped back, gathering as much dignity as she could manage. “Sorry.”</p>
<p>“Don’t be.” His entire body was still tingling from that sudden, shocking impact with hers. He managed a dangerous smile.
         “It was my pleasure.” He looked down at the little girl peering through Riley’s legs. “Now, who’s this?”
      </p>
<p>He found himself staring at a miniature Riley. Big, laughing eyes in a tiny, heart-shaped face framed by a wild tangle of
         dark curls.
      </p>
<p>She was so small. Once again he had to adjust his thinking. Maybe saddling a horse and riding the range wasn’t in the cards
         after all.
      </p>
<p>“This is my daughter, Summer.” Riley’s voice had gone from tense to soft and proud in the space of a heartbeat.</p>
<p><a id="page-31"></a>The little girl was wearing leggings under some sort of short skirt, topped off with a denim jacket. In her arms was a floppy-eared
         stuffed dog.
      </p>
<p>He knelt down on the porch so that his eyes were level with the little girl’s. “Hi, Winter.”</p>
<p>She wrinkled her nose. “Not Winter. I’m Summer.”</p>
<p>“Now how did I get that wrong? Hello, Summer. How old are you?”</p>
<p>“I’m this much.” She held up four fingers.</p>
<p>“Four. Wow. You’re almost all grown-up, aren’t you?”</p>
<p>She nodded proudly. “Mama says I’m a big girl, not a baby. What’s your name?”</p>
<p>“My name is Zane.”</p>
<p>“That’s a funny name.”</p>
<p>“Funnier than Winter?”</p>
<p>“Not Winter. Summer.” She glanced up at her mother. “He’s funny.”</p>
<p>“Yes, he is. Did you remember to pack all your toys?”</p>
<p>Summer nodded. “Now can I have a snack?”</p>
<p>“Yes, you may. I thought you could eat it on the drive to the ranch.”</p>
<p>“Okay.” The little girl skipped away.</p>
<p>Delia Cowling walked up behind Riley. “Good morning, Zane.”</p>
<p>“Delia.” He gave the old woman a smile. “I’m sorry you’re losing a boarder.”</p>
<p>“So am I.” She held the door. “Come on in. Their bags are all packed.”</p>
<p>He took in the tiny wheeled suitcase standing alongside the larger one. “That’s everything?”</p>
<p><a id="page-32"></a>Riley ducked her head. “We like to travel light.”
      </p>
<p>“I’m not complaining.” He chuckled. “You’ve made my job easy.”</p>
<p>Summer came barreling down the hallway carrying a little bag. “Mama, look what Auntie Delia made me.” She opened the bag to
         reveal a cinnamon biscuit, several raspberry-filled cookies, and a small bottle of water.
      </p>
<p>Riley glanced at the old woman. “What happened to the carrot sticks I cut up?”</p>
<p>“Summer and I nibbled them while you were finishing your packing, dear.” Delia tried for an innocent smile. “But I know how
         long the drive to the Lost Nugget is. A growing child needs her energy, so I thought I’d just add a few goodies.”
      </p>
<p>Before Riley could voice her disapproval Delia opened her arms and gave the young woman a hug. “I’m so glad I had a chance
         to meet you and Summer, though our time together was too brief. If you ever need a sitter, I hope you’ll call on me.”
      </p>
<p>“Thank you, Delia.” Riley stepped back a pace, while continuing to hold the older woman’s hands. “It was so kind of you to
         take us in on such short notice. I won’t forget your kindness.”
      </p>
<p>Delia scooped up the little girl. “Good-bye, Summer. I hope you’ll come back to visit me often.”</p>
<p>“And we’ll have tea and raspberry cookies?”</p>
<p>“Of course we will.” Delia kissed the little girl’s cheek before setting her on her feet.</p>
<p>“And Floppy can have some, too?”</p>
<p>“Floppy will always be invited to tea here, sweetheart.”</p>
<p>Zane thought about the woman he’d known in his <a id="page-33"></a>childhood as the stern gossip of Gold Fever. In the past year, after the painful loss of her brother, she’d transformed into
         this kindly stranger he barely recognized.
      </p>
<p>Who would have believed she’d be melting into a puddle over one little girl and her stuffed dog?</p>
<p>Riley picked up a child’s car seat and held the door as he hauled the luggage down the porch and out to the waiting truck.
         Summer skipped along behind them, gripping her bag of goodies, her stuffed dog, and a toy shaped like a television remote.
         She paused to turn and wave several times at the old woman who stood in the doorway.
      </p>
<p>Zane stowed the luggage before opening the back door of the truck. “I’d give you a hand with that, but I’ve never dealt with
         a kid’s car seat before.”
      </p>
<p>“That’s all right. I’m used to doing it.”</p>
<p>As she moved past him, he inhaled the fresh, lightly floral fragrance of her perfume, and felt a quick rush of heat that caught
         him by surprise.
      </p>
<p>He watched as Riley deftly inserted the seat belt through the slots of the seat before helping Summer up and into the truck.</p>
<p>With a click of the seat belt Riley turned and found him standing close. Too close. She took a quick step back. “Simple and
         safe.”
      </p>
<p>“So I see. Looks easy enough.” Zane held the front door and waited until she was seated before closing the door and hurrying
         around to the driver’s side.
      </p>
<p>As they started away, both Riley and Summer waved and blew kisses toward Delia Cowling, who did the same.</p>
<p>“Now can I eat my snack?” Summer asked.</p>
<p>Riley turned. “Yes, you may.”</p>
<p><a id="page-34"></a>In the rearview mirror Zane saw the little girl unwrap her biscuit and hold it toward the stuffed dog before taking a bite.
         “Mama says I have to share. Isn’t that good, Floppy?”
      </p>
<p>Minutes later he heard questions in an adult voice, followed by answers in childlike tones. A glance in the rearview mirror
         had him smiling. Summer was pressing buttons on her toy, which asked questions about simple things like the color of the sky
         or the sound made by a horse. Each time Summer answered correctly, the gadget praised her, and she in turn would relate her
         brilliance to her stuffed dog.
      </p>
<p>“See, Floppy. The sky is blue. And a horsey says neigh, neigh.”</p>
<p>Zane looked over and shared a smile with Riley. “For a minute there I thought we had a stowaway.”</p>
<p>Riley laughed. “I guess, if you’re not used to being around little kids, the sound of all those strange voices could throw
         you.”
      </p>
<p>“I’ll say. She’s a cutie. Looks a lot like her mother.”</p>
<p>“Thanks.” She turned to study the passing scenery, as though deliberately turning away from any form of flattery. “Once you
         get out of town, it’s really beautiful countryside.”
      </p>
<p>“Yeah. I’ve always loved the look of this part of the country. You have it all. Mountains. Rivers. Meadows. Forests.”</p>
<p>Riley nodded and continued drinking in the scenery, grateful for the chance to stare at something besides the driver. He was
         too handsome. Too charming. Too… distracting, with that dangerous smile and those laughing blue eyes.
      </p>
<p><a id="page-35"></a>She had no intention of being tempted by a smooth-talking cowboy, no matter how good-looking he was.
      </p>
<p>They veered off the highway and began the long stretch of road that gradually became gravel and dirt.</p>
<p>She turned toward her daughter in the backseat. “We’ll be at the Lost Nugget pretty soon, Summer.”</p>
<p>“Actually, you’ve been on Lost Nugget property for the past half hour,” Zane corrected.</p>
<p>Riley caught her breath. “I had no idea this was all part of the ranch.”</p>
<p>“The house is just beyond that rise.”</p>
<p>He pointed.</p>
<p>Up ahead the sprawling, three-story house came into view and she caught her breath at the sheer size and beauty of it. “I
         was so preoccupied on my first drive here, I didn’t really appreciate how big it is.”
      </p>
<p>“Biggest ranch in Montana.” Zane couldn’t hide his love and pride. “The original building was started by my great-grandfather,
         then the majority of the place finished by my grandfather and father and uncles.”
      </p>
<p>“You’re”—she swallowed—“a McCord?”</p>
<p>He glanced over with a look of surprise. “I thought you knew.”</p>
<p>“You never said your last name.” Her face flamed. All this time, she’d thought him one of the hired hands.</p>
<p>He was one of them. And that meant he wouldn’t be riding off to join the others. He would be living here. Sharing the same
         house…“Have you lived here all your life?”
      </p>
<p>He shook his head. “There was a long stretch of years when I was away.” He glanced over. “Long story. Maybe I’ll tell you
         some day.”
      </p>
<p><a id="page-36"></a>As they drew nearer and then drove around to the back of the house, Riley fell silent, awed not only by the size, but by the
         number of outbuildings. As if the house wasn’t impressive enough, with its three stories and wide, cathedral windows looking
         out on the most amazing vista, there were the barns, each one the size of a football stadium.
      </p>
<p>Zane brought the truck to a halt at the back door and opened the passenger side so Riley could step out and free little Summer
         from her car seat. Staring around with big eyes, the little girl kept hold of her floppy dog with one hand, the other tucked
         firmly in her mother’s. For her part, Riley seemed relieved to have a hand to cling to, as well.
      </p>
<p>As they walked through the mudroom, Zane paused to explain. “Our cook, Dandy, is a stickler for neatness. Anybody who doesn’t
         bother to clean their boots before stepping into his kitchen will get his famous hairy eyeball.”
      </p>
<p>Summer held back. “Mama, what’s a hairy eyeball?”</p>
<p>“The look you get from me when you forget to pick up your toys.”</p>
<p>“Oh.” The little girl smiled at Zane. “Does he take away your snack if you forget?”</p>
<p>“Yes, he does.” Zane kept a straight face as he showed them the big sink, where a foot-operated pedal turned on a giant stream
         of water. “Especially if we don’t scrape our boots or forget to wash our hands.”
      </p>
<p>As he stepped on the pedal, Summer gave a delighted squeal. “Look, Mama. No hands.”</p>
<p>Riley pretended to be amazed. “How did Zane do that?”</p>
<p><a id="page-37"></a>Summer shrugged before asking timidly, “Can you teach me?”
      </p>
<p>“Sure thing.” He lifted his foot, showing her how to step on the pedal.</p>
<p>She was absolutely thrilled when water spilled out.</p>
<p>“Can I do it by myself?”</p>
<p>“You bet.” Zane stepped back and Summer gingerly touched her little foot to the pedal, starting the water flowing again.</p>
<p>“Careful,” Riley said in an aside to Zane. “She may want to stay here for hours just turning on and off that spray.”</p>
<p>“I don’t mind.” Zane held the door to the kitchen. “But you may want to come back here later. Right now, I think I smell something
         sweet. Which means that Dandy must be baking some goodies.”
      </p>
<p>That was all it took to persuade Summer to leave the magic sink and follow her mother and Zane into the kitchen.</p>
<p>Dandy was just straightening from the oven, removing a cookie tin before setting it down on a trivet.</p>
<p>When he looked over, Zane was grinning from ear to ear. “What perfect timing. Do I smell chocolate chip?”</p>
<p>“You do.”</p>
<p>“Dandy, this is Riley Mason and her daughter, Winter.”</p>
<p>“It’s Summer,” the little girl corrected.</p>
<p>“Oh. Right. Summer. I keep forgetting.” He winked. “While you get acquainted, I’ll bring in your things.”</p>
<p>Dandy tossed aside his oven mitts before extending a hand. “Riley.” He smiled down at the little girl beside her. “Summer,
         I hope you like chocolate chip cookies.”
      </p>
<p><a id="page-38"></a>“I do.” She eyed the tray. “Are those as good as Mama’s?”
      </p>
<p>“Probably not. Nothing’s ever as good as Mama’s. But as soon as these are cool enough to eat, you can judge for yourself.”</p>
<p>“I can tell you right now, there’s no contest.” Riley was laughing. “Mine are actually from the store. I don’t think Summer
         has ever tasted home-baked cookies.”
      </p>
<p>“Why, that’s almost sinful. We’ll have to correct that problem immediately.” Dandy was chuckling. “No child should have to
         grow up eating store-bought cookies.”
      </p>
<p>“Okay. I have your luggage.” The door slammed behind Zane as he made his way through the kitchen. “Follow me.” He hefted their
         bags and led the way from the kitchen and through the enormous great room to the stairs leading to the second floor.
      </p>
<p>As Riley caught her daughter’s hand and followed, she struggled to hold back the nerves she’d been fighting all morning.</p>
<p>She desperately wanted this to work. Not just the job, which was critical for their survival, but also the location.</p>
<p>The Lost Nugget Ranch was as different from her life in Philadelphia as night was to day. She wasn’t at all certain she could
         fit in here, but she was determined to try.
      </p>
<p>Her safety, and that of her daughter, absolutely depended on it.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?18126eb2